export default __webpack_public_path__ + "static/media/No45Closed.6e08c092.jpg";